import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectSaving, selectSaved, selectError, selectQuiz, selectCreatedId } from '../selectors/quiz.selector';
import { quizActions } from '../actions/quiz.actions';
import { QuizValue } from '../models';

@Injectable({
    providedIn: 'root',
})
export class QuizFacade {
    private store = inject(Store);

    readonly loaded$ = (id: string) => this.store.select(selectLoaded(id));
    readonly loadedNonNullable$ = (id: string) => this.store.select(selectLoaded(id)).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = (id: string) => this.store.select(selectLoading(id));
    readonly saving$ = this.store.select(selectSaving);
    readonly saved$ = this.store.select(selectSaved);
    readonly quiz$ = (id: string) => this.store.select(selectQuiz(id));
    readonly quizNonNullable$ = (id: string) => this.store.select(selectQuiz(id)).pipe(filter((quiz) => quiz !== null));

    readonly quiz = (id: string) => this.store.selectSignal(selectQuiz(id));
    readonly loading = (id: string) => this.store.selectSignal(selectLoading(id));
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly error = (id: string) => this.store.selectSignal(selectError(id));
    readonly createdId = this.store.selectSignal(selectCreatedId);

    getQuiz(id: string): void {
        this.store.dispatch(quizActions.getQuiz({ id }));
    }

    createQuiz(value: QuizValue): void {
        this.store.dispatch(quizActions.createQuiz({ value }));
    }

    updateQuiz(id: string, value: QuizValue): void {
        this.store.dispatch(quizActions.updateQuiz({ id, value }));
    }

    deleteQuiz(id: string): void {
        this.store.dispatch(quizActions.deleteQuiz({ id }));
    }

    clear(): void {
        this.store.dispatch(quizActions.clear());
    }
}
